import React from 'react';
import { Box, CircularProgress } from '@mui/material';

function PageLoader() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{ color: '#114559' }}
      />
    </Box>
  );
}

export default PageLoader;
